"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
es6_promise_1.polyfill();
var axios_1 = require("axios");
var Vapi = /** @class */ (function () {
    function Vapi(options) {
        this.config = {};
        this.baseURL = options.baseURL;
        this.baseURLGo = options.baseURLGo;
        this.tocken = options.tocken;
        this.HttpGo = axios_1.default.create({
            baseURL: options.baseURLGo,
            headers: {
                Authorization: 'Bearer ' + options.tocken,
            },
        });
        return this;
    }
    Vapi.prototype.updateService = function (options) {
        var headers = {
            Authorization: 'Bearer ' + this.tocken,
        };
        if (options.idUser) {
            headers['Authorization'] = 'Bearer ' + options.idUser;
        }
        if (options.client) {
            headers['X-Tenant-ID'] = options.client;
        }
        if (options.user) {
            headers['X-Tenant-USER'] = options.user;
        }
        this.HttpGo = axios_1.default.create({
            baseURL: this.baseURLGo,
            headers: headers
        });
        return this;
    };
    Vapi.prototype.setHeaders = function (idTheme, config) {
        this.config = config;
    };
    Vapi.prototype.getTemplateOptions = function (obj) {
        var promise = {};
        var url = '/api/templates/get-options/' + obj.id + '?type=' + obj.type;
        if (obj.idChannel && !+obj.id) {
            url += '&canalId=' + obj.idChannel;
        }
        promise = this.HttpGo.get(url);
        return promise;
    };
    return Vapi;
}());
exports.Vapi = Vapi;
exports.default = Vapi;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-service-go-api/dist/index.js
// module id = FolR
// module chunks = 0